module.exports = __webpack_public_path__ + "img/PNG.21a2e6fd.svg";